module.exports = __webpack_public_path__ + "static/connect2025-300cf3bed048d5d5b33530640622d6ee.png";